<script>
    import Card from '$lib/Card.svelte';
    import H2 from '$lib/H2.svelte';
    import H3 from '$lib/H3.svelte';
    import ProductIcon from '$lib/ProductIcon.svelte';
    import { format_age_range } from '$lib/utils/format_ages';

    /** @type {Product[]} */
    export let products = [];
    export let title = '';
    export let title_href = '';
    /** @type {number | null | undefined} */
    export let limit = null;

    let className = '';
    export { className as class };

    const product_type_paths = {
        course: '/courses',
        worksheet: '/worksheets',
        bundle: '/bundles'
    };

    const visible_products =
        limit === null || limit === undefined
            ? products
            : products.slice(0, limit);
    const has_more_products =
        limit !== null && limit !== undefined && products.length > limit;

    /**
     * @param {Product} product
     */
    function get_product_href(product) {
        const base_path = product_type_paths[product.type] || title_href;

        if (!base_path || !product.slug) return null;

        return `${base_path}/${product.slug}`;
    }

    /**
     * @param {Product} product
     * @returns {Course | Worksheet | Extra | null}
     */
    function get_icon_product(product) {
        if (product.type === 'bundle') {
            return product.items.find((item) => item.icon) || null;
        }

        return product;
    }
</script>

{#if visible_products.length > 0}
    <Card class={className}>
        <H2 class="px-2 py-2" sm>
            {#if title_href}
                <a href={title_href} class="link">{title}</a>
            {:else}
                {title}
            {/if}
        </H2>
        <div
            class="space-y-4 border-t border-border-default divide-y divide-border-muted"
        >
            {#each visible_products as product (product.id)}
                {@const product_href = get_product_href(product)}
                {@const icon_product = get_icon_product(product)}
                {#if product_href}
                    <a href={product_href} class="flex gap-2 items-center pt-4">
                        {#if icon_product}
                            <ProductIcon product={icon_product} class="!w-14" />
                        {/if}
                        <div>
                            <H3 class="link">{product.title}</H3>
                            <p>
                                {format_age_range(
                                    product.min_age,
                                    product.max_age
                                )}
                            </p>
                        </div>
                    </a>
                {/if}
            {/each}
        </div>
        {#if has_more_products && title_href}
            <a href={title_href} class="link block mt-4 text-center">
                More
            </a>
        {/if}
    </Card>
{/if}
